import { defineMessages } from 'react-intl'

const messages = defineMessages({
  app_name: 'Smart Dispo',
  dashboard: 'Übersicht',
  about: 'Über',
  page_not_found_demo: 'Seite nicht gefunden demo',
  404: '404',
  warning_404_message: '404 Seite nicht gefunden',
  warning_404_description:
    'Es tut uns leid aber die angeforderte Seite existiert nicht.',
  settings: 'Einstellungen',
  language: 'Sprache',
  theme: 'Thema',
  responsive: 'Responsive',
  en: 'Englisch',
  de: 'Deutsch',
  bs: 'Bosnisch',
  ro: 'Rumänisch',
  sr: 'Serbian',
  dark: 'Dark',
  light: 'Light',
  ics: 'ICS',
  sign_out: 'Abmelden',
  sign_in: 'Anmelden',
  sign_up: 'Registrieren',
  sign_in_with_google: 'Mit Google anmelden',
  sign_in_with_facebook: 'Mit Facebook anmelden',
  sign_in_with_twitter: 'Mit Twitter anmelden',
  sign_in_with_github: 'Mit Github anmelden',
  link_with_google: 'Mit Google verbinden',
  link_with_facebook: 'Mit Facebook verbinden',
  link_with_twitter: 'Mit Twitter verbinden',
  link_with_github: 'Mit Github verbinden',
  my_account: 'Mein Konto',
  name: 'Name',
  email: 'E-Mail',
  password: 'Passwort',
  confirm_password: 'Passwort bestätigen',
  forgort_password: 'Passwort vergessen?',
  reset_password: 'Passwort zurücksetzten',
  change_password: 'Passwort ändern',
  change_email: 'E-Mail ändern',
  change_photo: 'Foto ändern',
  reset_password_hint: 'Ihre E-Mail eingeben',
  save: 'Speichern',
  delete_account: 'Konto löschen',
  select_file: 'Datei auswählen',
  cancel: 'Abbrechen',
  submit: 'Bestätigen',
  delete: 'Löschen',
  ok: 'OK',
  delete_account_dialog_title: 'Konto löschen?',
  delete_account_dialog_message:
    'Dein Konto wird gelöscht und mit ihm alle Daten!',
  email_not_verified: 'E-Mail ist nicht verifiziert!',
  email_verified: 'E-Mail ist verifiziert',
  send_verification_email: 'Verifizierungs E-Mail senden',
  send_verification_email_again: 'Verifizierungs E-Mail wieder senden',
  tasks: 'Aufträge',
  create_task: 'Aufgabe erstellen',
  edit_task: 'Aufgabe bearbeiten',
  create_vehicle: 'Fahrzeug erstellen',
  edit_vehicle: 'Fahrzeug bearbeiten',
  users: 'Benutzer',
  edit: 'Bearbeiten',
  online: 'Online',
  offline: 'Offline',
  no_connection_warning: 'Keine Verbindung!',
  title_label: 'Titel',
  title_hint: 'Titel eingeben',
  name_label: 'Name',
  name_hint: 'Name eingeben',
  fin_label: 'FIN',
  fin_hint: 'FIN eingeben',
  description_label: 'Beschreibung',
  description_hint: 'Beschreibung eingeben',
  vehicle_type_hint: 'Fahrzeugart auswählen',
  vehicle_type_label: 'Fahrzeugart',
  hint_autocomplete: 'Suchen...',
  not_match_found: 'Nichts gefunden',
  no_connection: 'Keine Verbindung',
  vehicles: 'Fahrzeuge',
  vehicle_types: 'Fahrzeugarten',
  companies: 'Unternehmen',
  create_company: 'Unternehmen erstellen',
  edit_company: 'Unternehmen bearbeiten',
  full_name_label: 'Voller Name',
  full_name_hint: 'Vollen Namen eingeben',
  vat_label: 'UID',
  vat_hint: 'UID eingeben',
  delete_vehicle_title: 'Fahrzeug löschen?',
  delete_vehicle_message: 'Fahrzeug wird gelöscht!',
  delete_vehicle_type_title: 'Fahrzeugart löschen?',
  delete_vehicle_type_message: 'Fahrzeugart wird gelöscht!',
  delete_company_title: 'Unternehmen löschen?',
  delete_company_message: 'Unternehmen wird gelöscht!',
  driver: 'Fahrer',
  drivers: 'Fahrer',
  create_driver: 'Fahrer erstellen',
  edit_driver: 'Fahrer bearbeiten',
  delete_driver_title: 'Fahrer löschen?',
  delete_driver_message: 'Fahrer wird gelöscht!',
  user_hint: 'Benutzer auswählen',
  user_label: 'Benutzer',
  container_tasks: 'Containeraufträge',
  container_task: 'Containerauftrag',
  create_container_task: 'Containerauftrag erstellen',
  edit_container_task: 'Containerauftrag bearbeiten',
  delete_container_task_title: 'Containerauftrag löschen?',
  delete_container_task_message: 'Containerauftrag wird gelöscht!',
  terminal: 'Terminal',
  terminals: 'Terminale',
  create_terminal: 'Terminal erstellen',
  edit_terminal: 'Terminal barbeiten',
  delete_terminal_title: 'Terminal löschen?',
  delete_terminal_message: 'Terminal wird gelöscht!',
  base_data: 'Stammdaten',
  administration: 'Administration',
  company_hint: 'Unternehmen auswählen',
  company_label: 'Unternehmen',
  refNr_hint: 'Referenznummer eingeben',
  refNr_label: 'Referenznummer',
  conWeight_hint: 'Eingeben',
  conWeight_label: 'Gewicht',
  relNr_hint: 'Freistellnummer eingeben',
  relNr_label: 'Freistellnummer',
  conNr_hint: 'Containernummer eingeben',
  conNr_label: 'Containernummer',
  sealNr_hint: 'Siegelnummer eingeben',
  sealNr_label: 'Siegelnummer',
  conSize_label: 'Containergröße',
  date_label: 'Datum',
  date2_label: 'Datum 2',
  time_label: 'Zeit',
  driver_hint: 'Fahrer auswählen',
  driver_label: 'Fahrer',
  driver2_hint: 'Fahrer2 auswählen',
  driver2_label: 'Fahrer2',
  vehicle_hint: 'Fahrzeug auswählen',
  vehicle_label: 'Fahrzeug',
  vehicle2_hint: 'Fahrzeug2 auswählen',
  vehicle2_label: 'Fahrzeug2',
  addresses: 'Adressen',
  street_hint: 'Strasse eingeben',
  street_label: 'Strasse',
  zip_hint: 'PLZ eingeben',
  zip_label: 'PLZ',
  place_hint: 'Ort eingeben',
  place_label: 'Ort',
  country_hint: 'Land eingeben',
  country_label: 'Land',
  lat_label: 'Lat',
  lng_label: 'Lng',
  create_address: 'Adresse hinzufügen',
  edit_address: 'Adresse bearbeiten',
  delete_address_title: 'Adresse löschen?',
  delete_address_message: 'Adresse wird gelöscht!',
  add_address: 'Adresse hinzufügen',
  match_hint: 'Match',
  address_hint: 'Adresse auswählen',
  address_label: 'Adresse',
  iso_code: 'ISO Ländercode',
  iso_code_hint: 'ISO Ländercode eingeben',
  iso_code_label: 'ISO Ländercode',
  iso_code_3: 'ISO-3 Ländercode',
  iso_code_3_hint: 'ISO-3 Ländercode eingeben',
  iso_code_3_label: 'ISO-3 Ländercode',
  dialing_code: 'Vorwahl',
  dialing_code_hint: 'Vorwahl eingeben',
  dialing_code_label: 'Vorwahl',
  is_Eu: 'EU Mitgliedstaat',
  is_Eu_label: 'EU Mitgliedstaat',
  new_place: 'Neuer Ort',
  places: 'Orte',
  countries: 'Länder',
  edit_country: 'Land bearbeiten',
  create_country: 'Land hinzufügen',
  delete_country_title: 'Land löschen?',
  delete_country_message: 'Land wird gelöscht!',
  delete_place: 'Ort löschen',
  edit_place: 'Ort bearbeiten',
  create_place: 'Ort hinzufügen',
  delete_place_title: 'Ort löschen?',
  delete_place_message: 'Ort wird gelöscht!',
  enable_screen_share: 'Multimonitor aktivieren',
  disable_screen_share: 'Multimonitor deaktivieren',
  select_label: 'Auswählen',
  import_label: 'Import',
  export_label: 'Export',
  swap_addresses: 'Adressen tauschen',
  delete_address: 'Adresse löschen',
  placeSelect_hint: 'Ort auswählen',
  open_filter: 'Filter öffnen',
  close_filter: 'Filter schließen',
  filter: 'Filter',
  select_field: 'Feld auswählen',
  sorting: 'Sortieren',
  date_picker_text: 'Datum auswählen',
  time_label_text: 'Zeit',
  time_picker_text: 'Zeit auswählen',
  add_filter: 'Filter hinzufügen',
  filters: 'Filter',
  operator_like_label: 'wie',
  operator_notlike_label: 'nicht wie',
  operator_equal_label: 'gleich',
  operator_notequal_label: 'nicht gleich',
  operator_novalue_label: 'kein Wert',
  change_sort_orientation: 'Sortierung ändern',
  delete_filter: 'Filter löschen',
  conSize_hint: 'Containergröße eingeben',
  pin_hint: 'PIN eingeben',
  pin_label: 'PIN',
  time_of_day_hint: 'Tageszeit auswählen',
  time_of_day_label: 'Tageszeit',
  out_hint: 'Raus eingeben',
  out_label: 'Raus',
  retNr_hint: 'retNr eingeben',
  retNr_label: 'retNr',
  turnIn_hint: 'turnIn eingeben',
  turnIn_label: 'TurnIn',
  dangerousGoods_label: 'Gefahrengut',
  heavy_label: 'Schwertransport',
  unsaddle_label: 'Absatteln',
  opened_label: 'Eröffnet',
  retrieved_label: 'Abruf',
  eDuty_label: 'E-Zoll',
  aviso_label: 'Aviso',
  customer_label: 'Kunde',
  customer_hint: 'Kunde auswählen',
  boat_hint: 'Schiff eingeben',
  boat_label: 'Schiff',
  port_hint: 'Hafen eingeben',
  port_label: 'Hafen',
  load_hint: 'Ladung eingeben',
  load_label: 'Ladung',
  bRef_hint: 'B-Ref eingeben',
  bRef_label: 'B_Ref',
  atNum_label: 'AT',
  atTxt_hint: 'AT eingeben',
  atTxt_label: 'AT',
  delete_time_of_day_title: 'Tageszeit löschen?',
  delete_time_of_day_message: 'Tageszeit wird gelöscht!',
  times_of_day: 'Tageszeiten',
  delete_time_of_day: 'Tageszeit löschen',
  edit_time_of_day: 'Tageszeit bearbeiten',
  create_time_of_day: 'Tageszeit erstellen',
  enable_case_sensitivity: 'G&K-Schreibung bechten',
  disable_case_sensitivity: 'G&K-Schreibung nicht beachten',
  enter_query_text: 'Suchtext eingeben',
  color_pick_label: 'Farbe auswählen',
  current_locale: 'de-DE',
  is_allowed_dangerousGoods_label: 'Darf Gefahrengut transportieren',
  is_allowed_heavy_hint: 'Darf schwere Ladung transportieren',
  driver_warning_title: 'Fahrer nicht berechtigt!',
  driver_warning_message:
    'Achtung! Ein oder mehrere Fahrer sind nicht berechtigt diese Ware zu verliefern!',
  error_required_field: 'Pflichtfeld',
  error_wrong_container_number: 'Ungültige Containernummer',
  grants: 'Berechtigungen',
  roles: 'Rollen',
  create_role: 'Rolle erstellen',
  edit_role: 'Rolle bearbeiten',
  delete_role_title: 'Rolle löschen?',
  delete_role_message: 'Rolle wird gelöscht!',
  grant_hint: 'Berechtigung auswählen',
  delete_grant: 'Berechtigung entfernen',
  add_grant: 'Berechtigung hinzufügen',
  edit_grant: 'Berechtigung bearbeiten',
  create_grant: 'Berechtigung erstellen',
  delete_grant_title: 'Berechtigung löschen?',
  delete_grant_message: 'Berechtigung wird gelöscht!',
  value_label: 'Wert',
  value_hint: 'Wert eingeben',
  email_label: 'E-Mail',
  email_hint: 'E-Mail eingeben',
  edit_user: 'Benutzer bearbeiten',
  is_admin_label: 'Administrator',
  container_task_statuses: 'Auftragsstatus',
  edit_container_task_status: 'Auftragsstatus bearbeiten',
  create_container_task_status: 'Auftragsstatus erstellen',
  delete_container_task_status_title: 'Auftragsstatus löschen?',
  delete_container_task_status_message: 'Auftragsstatus wird gelöscht!',
  select_terminal: 'Terminal auswählen',
  select_status: 'Status auswählen',
  allow_create_label: 'Hinzufügen erlauben',
  products: 'Artikel',
  delete_product_message: 'Artikel wird gelöscht!',
  delete_product_title: 'Artikel löschen?',
  edit_product: 'Artikel bearbeiten',
  create_product: 'Artikel erstellen',
  billing: 'Verrechnung',
  index_hint: 'Index eingeben',
  index_label: 'Index',
  prices: 'Preise',
  delete_price_title: 'Preise löschen?',
  delete_price_message: 'Preis wird gelöscht!',
  container_task_price_hint: 'Preis eingeben',
  container_task_price_label: 'Preis',
  create_container_task_price: 'Preis erstellen',
  edit_container_task_price: 'Preis bearbeiten',
  delete_container_task_price: 'Preis löschen',
  delete_container_task_price_title: 'Preis löschen?',
  delete_container_task_price_message: 'Preis wird gelöscht!',
  product_label: 'Artikel',
  product_hint: 'Artikel eingeben',
  unit_price_hint: 'Stückpreis eingeben',
  unit_price_label: 'Stückpreis',
  amount_hint: 'Stückzahl eingeben',
  amount_label: 'Stückzahl',
  subcontractor_label: 'Lieferant',
  subcontractor_hint: 'Lieferant eingeben',
  next_step: 'Nächster Schritt',
  documents: 'Dokumente',
  document_types: 'Dokumentenarten',
  edit_document_type: 'Dokumentenart bearbeiten',
  create_document_type: 'Dokumentenart erstellen',
  delete_document_type_title: 'Dokumentenart löschen?',
  delete_document_type_message: 'Dokumentenart wird gelöscht!',
  my_tasks: 'Aufträge',
  my_menu: 'Mein menü',
  archive: 'Auftragsarchiv',
  container_transport: 'Containertransport',
  send_to_driver: 'An Fahrer senden',
  document_type_label: 'Dokumentenart',
  document_type_hint: 'Dokumentenart auswählen',
  drop_or_select_file_label: 'Datei auswählen oder ablegen',
  download_tooltip: 'Herunterladen',
  delete_container_task_file_title: 'Datei löschen?',
  delete_container_task_file_message: 'Datei wird gelöscht!',
  edit_container_task_file: 'Datei bearbeiten',
  edit_driver_task: 'Fahrerauftrag bearbeiten',
  cmr_label: 'CMR',
  delete_container_task_status_workflow_title: 'Workflow löschen?',
  delete_container_task_status_workflow_message: 'Workflow wird gelöscht!',
  edit_container_task_status_workflow: 'Workflow bearbeiten',
  create_container_task_status_workflow: 'Workflow erstellen',
  conNrCheck_label: 'Containernummer prüfen',
  inputName_hint: 'Namen eingeben',
  inputName_label: 'Eingabefeld-Name',
  inputLabel_hint: 'Label eingeben',
  inputLabel_label: 'Eingabefeld-Label',
  inputHint_hint: 'Hint eingeben',
  inputHint_label: 'Eingabefeld-Hint',
  driver_task: 'Auftrag',
  match2_label: 'Match2',
  chats: 'Chats',
  edit_driver_task_workflow: 'Workflow bearbeiten',
  create_driver_task_workflow: 'Workflow erstellen',
  delete_driver_task_workflow_title: 'Workflow löschen?',
  delete_driver_task_workflow_message: 'Workflow wird gelöscht!',
  driver_task_workflows: 'Workflows',
  continue: 'Weiter',
  public_chats: 'Öffentliche Chats',
  is_unsaddled: 'Wurde abgesattelt?',
  finish_task: 'Auftrag abschließen',
  'link_with_google.com': 'Mit Google verbinden',
  'link_with_facebook.com': 'Mit Facebook verbinden',
  import: 'Import',
  export: 'Export',
  fieldName_label: 'Feld-Name',
  fieldName_hint: 'Feld-Namen eingeben',
  fieldValue_label: 'Wert',
  fieldValue_hint: 'Wert eingeben',
  refresh: 'Neu laden',
  create_container_task_pdf: 'Transportauftrag-PDF erstellen',
  download_cmr: 'CMR herunterladen',
  send_message: 'Nachricht senden',
  close: 'Schließen',
  select_user: 'Benutzer auswälen',
  my_location: 'Mein Standort:',
  predefined_messages: 'Vorgefertigte Nachrichten',
  delete_predefined_chat_message_title: 'Vorgefertigte Nachricht löschen?',
  delete_predefined_chat_message_message:
    'Vorgefertigte Nachricht wird gelöscht!',
  edit_contact: 'Kontakt bearbeiten',
  delete_contact_title: 'Kontakt löschen?',
  delete_contact_message: 'Kontakt wird gelöscht!',
  contacts: 'Kontakte',
  create_contact: 'Kontakt erstellen',
  firstName_label: 'Vorname',
  firstName_hint: 'Vornamen eingeben',
  lastName_label: 'Nachname',
  lastName_hint: 'Nachnamen eingeben',
  skype_label: 'Skype',
  skype_hint: 'Skype eingeben',
  load_more_label: 'Mehr...',
  write_message_hint: 'Nachricht...',
  changes_not_saved_warning: 'Änderungen nicht gespeichert!',
  terminal_notifications: 'Terminal Benachrichtigungen',
  contact_person_label: 'Kontaktperson',
  contact_person_hint: 'Kontaktperson auswählen',
  contact_persons: 'Kontaktpersonen',
  standard_label: 'Standardkontakt',
  select_operator: 'Operator auswählen',
  edit_vehicle_type: 'Fahrzeugart bearbeiten',
  create_vehicle_type: 'Fahrzeugart erstellen',
  truck_label: 'LKW',
  truck_hint: 'LKW auswählen',
  trailer_label: 'Anhänger',
  trailer_hint: 'Anhänger auswählen',
  car_label: 'PKW',
  container_label: 'Container',
  forklift_label: 'Gabelstapler',
  other_label: 'Sonstiges',
  delete_contact: 'Kontakt löschen',
  relCheck_label: 'Freistellnummer prüfen',
  conCheck_label: 'Containernummer prüfen',
  toggle_multiSelect: 'Aufträge markieren',
  copy: 'Kopieren',
  foto_uploaded_successfully: 'Foto wurde hochgeladen!',
  click_to_upload: 'Hier klicken, um Foto hochzuladen',
  skip: 'Überspringen',
  file_type: 'Datentyp',
  info_label: 'Info',
  input_label: 'Eingabe',
  foto_label: 'Foto',
  is_mandatory: 'Pflicht',
  turnInCheck_label: 'TurnIn prüfen',
  relNrCheck_label: 'Freistellnummer prüfen',
  select_all: 'Alle auswählen',
  multiselect_actions: 'Aktionen',
  personal_files: 'Dokumente',
  edit_personal_file: 'Dokument bearbeiten',
  delete_personal_file_title: 'Dokument löschen?',
  delete_personal_file_message: 'Dokument wird gelöscht!',
  delete_container_tasks_title: 'Aufträge löschen?',
  delete_container_tasks_message: 'Aufträge werden gelöscht!',
  signature_label: 'Unterschrift',
  is_import_label: 'Import',
  is_execution_label: 'Ausführung',
  mass_emails: 'Massen E-Mails',
  edit_mass_email: 'Massen E-Mail bearbeiten',
  create_mass_email: 'Massen E-Mail erstellen',
  delete_mass_email_title: 'Massen E-Mail löschen?',
  delete_mass_email_message: 'Massen E-Mail wird gelöscht!',
  subject_label: 'Betreff',
  subject_hint: 'Betreff eingeben',
  body_label: 'Textkörper',
  body_hint: 'Textkörper eingeben',
  emails_label: 'E-Mail Adressen',
  emails_hint: 'E-mail Adressen eingeben',
  copy_and_go_into: 'Kopieren und rein',
  import_export: 'Import/Export',
  container_task_requests: 'Containerauftrag-Anfragen',
  accept_label: 'Annehmen',
  deny_label: 'Ablehnen',
  canceled_label: 'Storniert',
  signature_wait: 'Dieser Vorgang kann einige Minuten dauern. Bitte warten!',
  clear: 'Neu',
  save_price_label: 'Preis speichern',
  data: 'Daten',
  max_file_size: 'Sie haben die maximale Uploadgröße überschritten!',
  search: 'Suchen',
  change_log: 'Änderungen',
  select_path: 'Änderungen auswählen',
  send_cmr_also: 'CMR auch an folgende E-Mail schicken:',
  is_cost_label: 'Kosten',
  open_label: 'Öffnen',
  is_not_driver_label: 'Kein Fahrer',
  driverVisable_label: 'Sichtbar für Fahrer',
  countryShort_hint: 'Länderkürzel eingeben',
  countryShort_label: 'Länderkürzel',
  comment_label: 'Bemerkung',
  comment_hint: 'Bemerkung eingeben',
  isSplit_label: 'Split',
  split_label: 'Split',
  notifications: 'Benachrichtigungen',
  short_name_label: 'Kürzel',
  short_name_hint: 'Kürzel eingeben',
  driver_task_files: 'Dokumente',
  vehicleSelection_label: 'Fahrzeugauswahl',
  overwrite_label: 'Überschreiben',
  onlySecondDriver_label: 'Nur für zweiten Fahrer',
  mark_all_notifications_as_read: 'Alle als gelesen markieren',
  personal_files_users: 'Benutzerdokumente',
  checks_label: 'Checks',
  checks_hint: 'Checks auswählen',
  delete_company_contact_message: 'Kontakt wird gelöscht!',
  delete_company_contact_title: 'Kontakt löschen?',
  edit_company_contact: 'Kontakt bearbeiten',
  create_company_contact: 'Kontakt erstellen',
  customer_tasks: 'Aufträge',
  isArrival_label: 'Ist Ankunft',
  isLoadBegin_label: 'Ist Ladebeginn',
  isLoadEnd_label: 'Ist Ladeende',
  isDeparture_label: 'Ist Abfahrt',
  isLock_label: 'Andere Aufträge sperren',
  previous_step: 'Vorheriger Schritt',
  loadRef_label: 'LadeRef',
  loadRef_hint: 'LadeRef eingeben',
  my_tasks_archive: 'Mein Archiv',
  month: 'Monat',
  week: 'Woche',
  day: 'Tag',
  agenda: 'Liste',
  next_week: 'Nächster Monat',
  previous_week: 'Vorheriger Monat',
  today: 'Heute',
  container_planning: 'Containerplanung',
  date: 'Datum',
  time: 'Uhrzeit',
  container: 'Container',
  edit_container_planning_event: 'Eintrag bearbeiten',
  delete_event_title: 'Eintrag löschen?',
  delete_event_message: 'Eintrag wird gelöscht!',
  startTime_label_text: 'Start',
  endTime_label_text: 'Ende',
  Notes_hint: 'Notiz eingeben',
  Notes_label: 'Notiz',
  more: 'weitere',
  is_export_label: 'Export',
  retry: 'Erneut versuchen',
  error_label: 'Fehler',
  export_nr: 'ExportNr',
  toggle_report_drawer: 'Berichte öffnen',
  count_reports: 'Zähler',
  from_label: 'Von',
  from_hint: 'Name eingeben',
  replyTo_label: 'Antworten auf',
  replyTo_hint: 'Email eingeben',
  isRefrigerated_label: 'Kühltransport',
  ocr_hint: 'Erkannter text',
  ocr_label: 'Erkannter text',
  keywords_hint: 'Stichwörter',
  keywords_label: 'Stichwörter',
  driver_task_error_title_kaywordsNotIncluded: 'Foto unscharf',
  driver_task_error_message_kaywordsNotIncluded:
    'Die Wörter   {data}   kann man nicht erkennen! Bitte nochmal aufnehmen.',
  driver_task_error_title_undefined: 'Foto not clear',
  driver_task_error_message_undefined:
    'The words {data} are not recognisable! Take the picture again.',
  error_name_exists: 'Dieser Name exisitert bereits!',
  subcontractor: 'Subfrächter',
  company: 'Unternehmen',
  puma_excel_export: 'Puma Excel Export',
  cost: 'Kosten',
  earnings: 'Einnahmen',
  number_of_tasks: 'Anzahl der Aufträge',
  calendar_week: 'KW',
  recount_statistics: 'Statistik neu berechnen',
  resource_warining_title: 'Resourcenaufwändig!',
  resource_warining_message:
    'Achtung! Diese Operation ist sehr resourcenaufwändig.',
  shipping_company_label: 'Reederei',
  shipping_company_hint: 'Reederei eingeben',
  staff: 'Angestellter',
  staffs: 'Personal',
  edit_staff: 'Angestellten bearbeiten',
  create_staff: 'Angestellten hinzufügen',
  delete_staff_title: 'Angestellten löschen?',
  delete_staff_message: 'Angestellter wird gelöscht!',
  first_name_hint: 'Vorname eingeben',
  first_name_label: 'Vorname',
  last_name_hint: 'Nachname eingeben',
  last_name_label: 'Nachname',
  second_name_hint: 'Zweitnamen eingeben',
  second_name_label: 'Zweitname',
  passport_number_hint: 'Passnummer eingeben',
  passport_number_label: 'Passnummer',
  birthdate_label: 'Geburtsdatum',
  birth_place_label: 'Gebuertsort',
  birth_place_hint: 'Gebuertsort eingeben',
  nationality_label: 'Nationalität',
  nationality_hint: 'Nationalität eingeben',
  confesion_label: 'Konfession',
  confesion_hint: 'Konfession eingeben',
  marital_date_label: 'Familienstand Datum',
  marital_status_label: 'Familienstand',
  marital_status_hint: 'Familienstand eingeben',
  registered_label: 'Angemeldet',
  deregistered_label: 'Abgemeldet',
  all_label: 'Alle',
  own_label: 'Eigen',
  isOwn_label: 'Eigen',
  edit_staff_file: 'Angestellten Datei berabeiten',
  add_staff_files: 'Angestelltendateien hinzfügen',
  delete_staff_file_title: 'Angestellten Datei löschen?',
  delete_staff_file_message: 'Angestellten Datei wird gelöscht!',
  cmrAddress1_label: 'CMR1',
  cmrAddress2_label: 'CMR2',
  edit_staff_salary: 'Angestellten Lohn berabeiten',
  delete_staff_salary_title: 'Angestellten Lohn löschen?',
  delete_staff_salary_message: 'Angestellten Lohn wird gelöscht!',
  receiver_hint: 'Empfänger eingeben',
  receiver_label: 'Empfänger',
  active_label: 'Aktiv',
  netto_salary_hint: 'Nettolohn eingeben',
  netto_salary_label: 'Nettolohn',
  brutto_salary_hint: 'Bruttolohn eingeben',
  brutto_salary_label: 'Bruttolohn',
  transfer_hint: 'Zu überweisenden Betrag eingeben',
  transfer_label: 'Überweisen',
  cash_payment_hint: 'Barzahlung eingeben',
  cash_payment_label: 'Barzahlung',
  show_label: 'Wird angezeigt',
  container_task_statistics: 'Statistiken',
  departments: 'Abteilungen',
  department: 'Abteilung',
  create_department: 'Abteilung erstellen',
  edit_department: 'Abteilung bearbeiten',
  delete_department_title: 'Abteilung löschen?',
  delete_department_message: 'Abteilung wird gelöscht!',
  registrations: 'Anmeldungen',
  registration_types: 'Anmeldungen',
  registration_type: 'Anmeldung',
  create_registration_type: 'Anmeldung erstellen',
  edit_registration_type: 'Anmeldung bearbeiten',
  delete_registration_type_title: 'Anmeldung löschen?',
  delete_registration_type_message: 'Anmeldung wird gelöscht!',
  staff_registrations: 'Angestellten-Anmeldungen',
  staff_registration: 'Angestellten-Anmeldung',
  create_staff_registration: 'Angestellten-Anmeldung erstellen',
  edit_staff_registration: 'Angestellten-Anmeldung bearbeiten',
  delete_staff_registration_title: 'Angestellten-Anmeldung löschen?',
  delete_staff_registration_message: 'Angestellten-Anmeldung wird gelöscht!',
  registration_date: 'Anmeldedatum',
  unregistration_date: 'Abmeldedatum',
  probation_date: 'Probezeit',
  vacation_days_label: 'Urlaubstage',
  vacation_days_hint: 'Urlaubstage eingeben',
  add_new_row: 'Hinzufügen',
  old_street_label: 'Straße Alt',
  old_place_label: 'Ort Alt',
  old_zip_label: 'Plz Alt',
  old_country_label: 'Land Alt',
  office_phone_hint: 'Firmen Telefonnummer eingeben',
  office_phone_label: 'Firmen Telefonnummer',
  private_phone_hint: 'Private Telefonnummer eingeben',
  private_phone_label: 'Private Telefonnummer',
  wage_data: 'Lohndaten',
  drivers_licences: 'Führerscheine',
  invalid_bic: 'Ungültiger BIC',
  invalid_iban: 'Ungültiger IBAN',
  delete_entry_title: 'Eintrag löschen?',
  delete_entry_message: 'Eintrag wird gelöscht!',
  staff_calendar: 'Kalender',
  contract_end_date_label: 'Befristung',
  select_calendar_events: 'Events auswählen',
  view: 'Ansicht',
  birthdays: 'Geburtstage',
  contract_ends: 'Befristungen',
  austrian_holidays: 'Österreichische Feiertage',
  german_holidays: 'Deutsche Feiertage',
  list_month: 'Monatsliste',
  familiy: 'Angehörige',
  boss_label: 'Abteilungsvorstand',
  boss_hint: 'Abteilungsvorstand auswählen',
  vacation_type_label: 'Art',
  vacation_type_hint: 'Art auswählen',
  whole_day_label: 'Ganztags',
  half_day_label: 'Halbtags',
  create_staff_vacation: 'Urlaub erstellen',
  edit_staff_vacation: 'Urlaub bearbeiten',
  vacation: 'Urlaub',
  correction: 'Korrektur',
  delete_staff_vacation_title: 'Urlaub löschen?',
  delete_staff_vacation_message: 'Urlaub wird gelöscht!',
  ill: 'Krank',
  consultation: 'Arztbesuch',
  unpaid_vacation: 'Unbezahlter Urlaub',
  absence_type_label: 'Abwesenheitsart',
  absence_type_hint: 'Abwesenheitsart auswählen',
  edit_staff_absence: 'Abwesenheit bearbeiten',
  delete_staff_absence_title: 'Abwesenheit löschen?',
  delete_staff_absence_message: 'Abwesenheit wird gelöscht!',
  from_time_label_text: 'Von',
  to_time_label_text: 'Bis',
  completeContainerTask_label: 'Auftrag abschließen',
  pink: 'Pink',
  customerVisible_label: 'Sichtbar für Kunden',
  isTrash_label: 'Abfall',
  is_allowed_can45ft_hint: 'Darf 45 Fuß Container transportieren',
  unsaddleSection_label: 'Absatteln',
  cmr_name_label: 'Name vom Kunden',
  renting: 'Vermietung',
  edit_rent: 'Vermietung bearbeiten',
  delete_rent_message: 'Vermietung wird gelöscht!',
  delete_rent_title: 'Vermietung löschen?',
  start_date_label: 'Start',
  end_date_label: 'Ende',
  delete_renting_price_message: 'Preis wird gelöscht!',
  delete_renting_price_title: 'Preis löschen?',
  ar_number_label: 'AR-Nummer',
  price_label: 'Preis',
  type_label: 'Typ',
  type_hint: 'Typ auswählen',
  controlled_label: 'Kontrolliert',
  status_label: 'Status',
  download: 'Download',
  start: 'Start',
  end: 'Ende',
  move_container_tasks_title: 'Auftrag verschieben?',
  move: 'Verschieben',
  writeCMR_label: 'CMR schreiben',
  writeCMR_warning: 'CMR schreiben!!!',
  delete_driver_task_title: 'Auftrag löschen?',
  delete_driver_task_message: 'Auftrag wird gelöscht!',
  is_finished_label: 'Abgeschlossen',
  restricted_transferability_label: 'Vinkulierung',
  initial_registration_date_label: 'Erstzulassung',
  leasing_end_date_label: 'Leasing ende',
  return_label: 'Return',
  error_already_rented: 'Fahrzeug bereits vermietet!',
  container_tasks_description: 'Aufträge für die Disponenten',
  customer_tasks_description: 'Aufträge für die Kunden',
  my_tasks_description: 'Meine Aufträge',
  chats_description: 'Chatte mit allen benutzern der App',
  personal_files_description: 'Dokumente zu all meinen Aufträgen',
  my_tasks_archive_description: 'Archiv von all meinen Aufträgen',
  drivers_description: 'Alle Fahrer verwalten',
  companies_description: 'Alle Kunden verwalten',
  addresses_description: 'MAlle Adressen verwalten',
  vehicles_description: 'Alle Fahrzeuge verwalten',
  renter_label: 'Mieter',
  renter_hint: 'Mieter eingeben',
  datamanagement: 'Datenverwaltung',
  warehouses: 'Lager',
  create_warehouse: 'Lager erstellen',
  edit_warehouse: 'Lager bearbeiten',
  delete_warehouse_title: 'Lager löschen?',
  delete_warehouse_message: 'Das Lager und all seine Daten werden gelöscht!',
  units: 'Einheiten',
  create_unit: 'Einheit erstellen',
  edit_unit: 'Einheit bearbeiten',
  delete_unit_title: 'Einheit löschen?',
  delete_unit_message: 'Die Einheit und all ihre Daten werden gelösct!',
  clients: 'Mandanten',
  create_client: 'Mandanten erstellen',
  edit_client: 'Mandanten bearbeiten',
  delete_client_title: 'Mandanten löschen',
  delete_client_message: 'Mandant und all seine Daten werden gelöscht!',
  client_data: 'Mandantendaten',
  items: 'Artikel',
  create_item: 'Artikel erstellen',
  edit_item: 'Artikel bearbeiten',
  delete_item_title: 'Artikel löschen?',
  delete_item_message: 'Artikel und all seine Daten werden gelöscht!',
  create_task_type: 'Auftragsart erstellen',
  edit_task_type: 'Auftragsart bearbeiten',
  delete_task_type_title: 'Auftragsart löschen?',
  delete_task_type_message: 'Auftragsart und all seine Daten werden gelöscht!',
  task_types: 'Auftragsarten',
  create_warehouse_task_workflow: 'Workflow erstellen',
  edit_warehouse_task_workflow: 'Workflows bearbeiten',
  delete_warehouse_task_workflow_title: 'Workflow löschen?',
  delete_warehouse_task_workflow_message:
    'Der Workflow und all seine Daten werden gelöscht!',
  warehouse_task_workflows: 'Workflows',
  select_client: 'Mandantenauswahl',
  user_clients: 'Meine Mandanten',
  warehouse_tasks: 'Lageraufträge',
  create_warehouse_task: 'Lagerauftrag erstellen',
  edit_warehouse_task: 'Lagerauftrag bearbeiten',
  delete_warehouse_task_title: 'Lagerauftrag löschen?',
  delete_warehouse_task_message:
    'Der Lageraufrag und all seine Daten werden gelöscht!',
  taskNr_label: 'Lieferscheinnummer',
  orderNr_label: 'Auftragsnummer',
  taskType_label: 'Auftragsart',
  warehouse_task_content: 'Einheiten',
  add: 'Hinzufügen',
  sscc_label: 'SSCC',
  unit_label: 'Einheit',
  warehouse_label: 'Lager',
  code93_label: 'Code 93',
  code94_label: 'Code 94',
  warehouse_task_movements: 'Ware',
  create_warehouse_task_movement: 'Ware hinzufügen',
  edit_warehouse_task_movement: 'Ware bearbeiten',
  delete_warehouse_task_movement_title: 'Ware löschen?',
  delete_warehouse_task_movement_message:
    'Die Ware und all die Daten dazu werden gelöscht!',
  delete_WTMSelectedRow_title: 'Augewählte Ware löschen?',
  delete_WTMSelectedRow_message: 'Die Ware und all ihre Daten werden gelöscht!',
  delete_WTMRow_title: 'Ware löschen?',
  delete_WTMRow_message: 'Die Ware und all ihre Daten werden gelöscht',
  delete_all: 'Alle löschen',
  isControlled_label: 'Kontrolliert',
  pitch_label: 'Stellplatz',
  code_93_label: 'Code 93',
  code_94_label: 'Code 94',
  nettoWeight_label: 'Nettogewicht',
  quantity_label: 'Menge',
  item_label: 'Artikel',
  itemUnit_label: 'Artikeleinheit',
  charge_label: 'Charge',
  bestBeforeDate_label: 'MHD',
  contentQuantity_label: 'Inhaltmenge',
  contentNettoWeight_label: 'Inhalt Netto',
  multiMode_label: 'Mehrere Artikel',
  singleMode_label: 'Ein Artikel',
  delete_WTMCSelectedRow_title: 'Augewählte Ware löschen?',
  delete_WTMCSelectedRow_message:
    'Die Ware und all ihre Daten werden gelöscht!',
  delete_WTMCRow_title: 'Ware löschen?',
  delete_WTMCRow_message: 'Die Ware und all ihre Daten werden gelöscht',
  next: 'Weiter',
  back: 'Zurück',
  from_date_label: 'Ab',
  currentStep_label: 'Schrit',
  operator_contains_label: 'beinhaltet',
  isMultymode_label: 'Multymode',
  next_label: 'Weiter',
  add_label: 'Hinzufügen',
  item_quantity_label: 'Stückzahl',
  trucks: 'LKWs',
  create_truck: 'LKW erstellen',
  edit_truck: 'LKW bearbeiten',
  delete_truck_title: 'LKW löschen?',
  delete_truck_message: 'Der LKW und all seine Daten werden gelöscht!',
  trailers: 'Anhänger',
  create_trailer: 'Anhänger erstellen',
  edit_trailer: 'Anhänger bearbeiten',
  delete_trailer_title: 'Anhänger löschenr?',
  delete_trailer_message: 'Anhänger und all seine Daten werden gelöscht!',
  evaluation: 'Auswertungen',
  stock: 'Lagerbestand',
  number_label: 'Nummer',
  pitches_label: 'Stellplätze',
  recalculate_from_date: 'Ab hier nachberechnen',
  recalculate_for_date: 'Nachberechnen',
  delivery_note: 'Lieferschein',
  barcode_type: 'Barcode Art',
  isDouble_label: 'Doppelt',
  sum_field_hint: 'Summierfelder eingeben',
  sum_field_label: 'Summierfelder',
  container_number_label: 'Container Nummer',
  container_size_label: 'Container Größe',
  seal_number_label: 'Siegelnummer',
  release_number_label: 'Freistellnummer',
  tara_label: 'Tara',
  lot_label: 'Lot',
  charge_report: 'Chargebericht',
  input_date: 'Eingangsdatum',
  input_task: 'Eingangsauftrag',
  output_date: 'Ausgangsdatum',
  output_task: 'Ausgangsauftrag',
  total: 'Gesamt',
  item_number_label: 'ArtikelNr',
  quantity_total_label: 'Stückzahl',
  excel_download: 'Excel herunterladen',
  warehouse_price: 'Lagerpreis',
  edit_warehouse_price: 'Lagerpreis bearbeiten',
  warehouse_price_label: 'Lagerpreis',
  default_handling_price_label: 'Standard Handlingpreis',
  default_stuffing_price_label: 'Standard Stuffingpreis',
  flat_label: 'Flat',
  delete_warehouse_price_title: 'Lagerpreis löschen?',
  delete_warehouse_price_message: 'Lagerpreis wird gelöscht!',
  hide_zeroes: 'Nuller verbergen',
  billing_report: 'Abrechnung',
  separator: 'Typ',
  hs_total: 'HS Total',
  stock_total: 'Stand Total',
  handling: 'Handling',
  stuffing: 'Stuffing',
  delete_warehouse_tasks_title: 'Ausgewählte Aufträge löchen?',
  delete_warehouse_tasks_message: 'Ausgewählte Aufträge werden gelöscht!',
  nr: 'Nr',
  from: 'Von',
  to: 'Bis',
  days: 'Tage',
  weeks: 'Wochen',
  taskPrice_label: 'Auftragspreis',
  chargePrice_label: 'Chargepreis',
  minWeeks_label: 'Min Wochen',
  barcodes: 'Barcodes',
  csv_export: 'CSV Export',
  csv_import: 'CSV Import',
  generate_sscc: 'SSCC generieren',
  handling_price_label: 'Handlingpreis',
  stuffing_price_label: 'Stuffingpreis',
  edit_movement_price: 'Bewegungspreise bearbeiten',
  initial_stock: 'Anfangsbestand',
  subtotal: 'Zwischensumme',
  input: 'Eingang',
  output: 'Ausgang',
  pdf_download: 'PDF Download',
  report: 'Bericht',
  refresh_calculation: 'Berechnung starten',
  wek_label: 'WEK',
  lsk_label: 'LSK',
  stock_price: 'Lagerpreis',
  hs_input: 'HS Eingang',
  hs_output: 'HS Ausgang',
  isGenerateSSCC_label: 'SSCC generieren',
  isGrouped: 'Details',
  isPicked_label: 'Pick',
  unloadingDate_label: 'Entladung',

  grant_create_vehicle: 'Fahrzeuge erstellen',
  grant_create_vehicle_type: 'Fahrzeugarten erstellen',
  grant_create_driver: 'Fahrer erstellen',
  grant_create_company: 'Unternehmen erstellen',
  grant_create_country: 'Länder erstellen',
  grant_create_place: 'Orte erstellen',
  grant_create_address: 'Adressen erstellen',
  grant_create_time_of_day: 'Tageszeiten erstellen',
  grant_create_terminal: 'Terminals erstellen',
  grant_create_container_task: 'Containeraufträge erstellen',
  grant_create_container_task_status: 'Auftragsstatuse erstellen',
  grant_create_product: 'Artikel erstellen',
  grant_edit_vehicle: 'Fahrzeuge bearbeiten',
  grant_edit_vehicle_type: 'Fahrzeugarten bearbeiten',
  grant_edit_driver: 'Fahrer bearbeiten',
  grant_edit_company: 'Unternehmen bearbeiten',
  grant_edit_country: 'Länder bearbeiten',
  grant_edit_place: 'Orte bearbeiten',
  grant_edit_address: 'Adressen bearbeiten',
  grant_edit_time_of_day: 'Tageszeiten bearbeiten',
  grant_edit_terminal: 'Terminals bearbeiten',
  grant_edit_container_task: 'Containeraufträge bearbeiten',
  grant_edit_container_task_status: 'Auftragsstatuse bearbeiten',
  grant_edit_product: 'Artikel bearbeiten',
  grant_delete_vehicle: 'Fahrzeuge löschen',
  grant_delete_vehicle_type: 'Fahrzeugarten löschen',
  grant_delete_driver: 'Fahrer löschen',
  grant_delete_company: 'Unternehmen löschen',
  grant_delete_country: 'Länder löschen',
  grant_delete_place: 'Orte löschen',
  grant_delete_address: 'Adressen löschen',
  grant_delete_time_of_day: 'Tageszeiten löschen',
  grant_delete_terminal: 'Terminals löschen',
  grant_delete_container_task: 'Containeraufträge löschen',
  grant_delete_container_task_status: 'Auftragsstatuse löschen',
  grant_delete_product: 'Artikel löschen',
  grant_read_vehicles: 'Fahrzeuge sehen',
  grant_read_vehicle_types: 'Fahrzeugarten sehen',
  grant_read_drivers: 'Fahrer sehen',
  grant_read_companies: 'Unternehmen sehen',
  grant_read_countries: 'Länder sehen',
  grant_read_places: 'Orte sehen',
  grant_read_addresses: 'Adressen sehen',
  grant_read_times_of_day: 'Tageszeiten sehen',
  grant_read_terminals: 'Terminals sehen',
  grant_read_container_tasks: 'Containeraufträge sehen',
  grant_read_container_task_statuses: 'Auftragsstatuse sehen',
  grant_read_products: 'Artikel sehen',
  grant_create_prices: 'Preise erstellen',
  grant_edit_prices: 'Preise bearbeiten',
  grant_delete_prices: 'Preise löschen',
  grant_read_prices: 'Preise sehen',
  grant_read_documents: 'Dokumente sehen',
  grant_create_document_type: 'Dokumentenarten erstellen',
  grant_edit_document_type: 'Dokumentenarten bearbeiten',
  grant_delete_document_type: 'Dokumentenarten löschen',
  grant_create_container_task_price: 'Preis hinzufügen',
  grant_edit_container_task_price: 'Preis bearbeiten',
  grant_delete_container_task_price: 'Preis löschen',
  grant_read_container_task_prices: 'Preise sehen',
  grant_read_container_task_files: 'Dokumente sehen',
  grant_create_container_task_file: 'Dokumente erstellen',
  grant_edit_container_task_file: 'Dokumente bearbeiten',
  grant_delete_container_task_file: 'Dokumente löschen',
  grant_read_container_task_status_workflows:
    'Containerauftrag-Workflows sehen',
  grant_create_container_task_status_workflow:
    'Containerauftrag-Workflows erstellen',
  grant_edit_container_task_status_workflow:
    'Containerauftrag-Workflows bearbeiten',
  grant_delete_container_task_status_workflow:
    'Containerauftrag-Workflows löschen',
  grant_read_driver_task_workflows: 'Fahrerauftrag-Workflows sehen',
  grant_create_driver_task_workflow: 'Fahrerauftrag-Workflows erstellen',
  grant_edit_driver_task_workflow: 'Fahrerauftrag-Workflows bearbeiten',
  grant_delete_driver_task_workflow: 'Fahrerauftrag-Workflows löschen',
  grant_read_driver_task_workflow_statuses:
    'Fahrerauftrag-Workflowstatus sehen',
  grant_create_driver_task_workflow_status:
    'Fahrerauftrag-Workflowstatus erstellen',
  grant_read_contacts: 'Kontakte sehen',
  grant_create_contact: 'Kontakte erstellen',
  grant_delete_contact: 'Kontakte löschen',
  grant_edit_contact: 'Kontakte bearbeiten',
  grant_read_personal_files: 'Persönliche Dokumente sehen',
  grant_create_personal_file: 'Persönliche Dokumente erstellen',
  grant_delete_personal_file: 'Persönliche Dokumente löschen',
  grant_edit_personal_file: 'Persönliche Dokumente bearbeiten',
  grant_read_mass_emails: 'Massen E-Mails sehen',
  grant_create_mass_email: 'Massen E-Mails erstellen',
  grant_delete_mass_email: 'Massen E-Mails löschen',
  grant_edit_mass_email: 'Massen E-Mails bearbeiten',
  grant_read_container_task_requests: 'Containerauftrag-Anfragen sehen',
  grant_edit_container_task_request: 'Containerauftrag-Anfragen bearbeiten',
  grant_trigger_container_task_request_accepted:
    'Containerauftrag-Anfragen akzeptieren',
  grant_trigger_container_task_request_rejected:
    'Containerauftrag-Anfragen ablehnen',
  grant_trigger_send_mass_email: 'Massen-E-mails versenden',
  grant_trigger_send_task_to_driver: 'Auftrag an Fahrer senden',
  grant_trigger_container_task_next_step:
    'Containerauftrag in nächsten Schritt verschieben',
  grant_trigger_rel_numbers_to_check: 'Freistellnummer prüfen',
  grant_trigger_con_numbers_to_check: 'Containernummer prüfen',
  grant_trigger_turnIn_numbers_to_check: 'TurnIn prüfen',
  grant_read_container_task_change_log: 'Containerauftrag Changelog sehen',
  grant_read_change_log_companies: 'Firmen Changelog sehen',
  grant_read_change_log_container_tasks: 'Containeraufträge Changelog sehen',
  grant_read_change_log_drivers: 'Fahrer Changelog sehen',
  grant_read_change_log_vehicles: 'Fahrzeuge Changelog sehen',
  grant_edit_user_companies: 'Benutzer eines Unternehmen bearbeiten',
  grant_trigger_container_task_previous_step:
    'Containerauftrag vorheriger Schritt',
  grant_read_container_planning_events: 'Containerplanung-Events sehen',
  grant_edit_container_planning_event: 'Containerplanung-Events bearbeiten',
  grant_create_container_planning_event: 'Containerplanung-Events erstellen',
  grant_delete_container_planning_event: 'Containerplanung-Events löschen',
  grant_read_container_planning_files: 'Containerplanung-Dateien sehen',
  grant_edit_container_planning_file: 'Containerplanung-Dateien bearbeiten',
  grant_read_times_of_day_counter: 'Container auftrags Zähler lesen',
  grant_edit_excel_exports: 'Excel Exports bearbeiten',
  grant_read_excel_exports: 'Excel Exports sehen',
  grant_trigger_recount_statistics: 'Statistik neu berechnen',
  grant_read_driver_count: 'Fahrer Statistiken sehen',
  grant_edit_driver_count: 'Fahrer Statistiken bearbeiten',
  grant_read_subcontractor_count: 'Subfrächter Statistiken sehen',
  grant_edit_subcontractor_count: 'Subfrächter Statistiken bearbeiten',
  grant_read_container_count: 'Container Statistiken sehen',
  grant_edit_container_count: 'Container Statistiken bearbeiten',
  grant_read_truck_count: 'Lastwagen Statistiken sehen',
  grant_edit_truck_count: 'Lastwagen Statistiken bearbeiten',
  grant_create_staff: 'Angestellten hinzufügen',
  grant_edit_staff: 'Angestellten bearbeiten',
  grant_delete_staff: 'Angestellten löschen',
  grant_read_staffs: 'Angestellte lesen',
  grant_create_staff_file: 'Angestellten Datei hinzufügen',
  grant_edit_staff_file: 'Angestellten Datei bearbeiten',
  grant_delete_staff_file: 'Angestellten Datei löschen',
  grant_read_staff_files: 'Angestellte Datein lesen',
  grant_create_staff_salary: 'Angestellten Lohn hinzufügen',
  grant_edit_staff_salary: 'Angestellten Lohn bearbeiten',
  grant_delete_staff_salary: 'Angestellten Lohn löschen',
  grant_read_staff_salaries: 'Angestellte Löhne lesen',
  grant_read_departments: 'Abteilungen sehen',
  grant_edit_department: 'Abteilungen bearbeiten',
  grant_create_department: 'Abteilungen erstellen',
  grant_delete_department: 'Abteilungen löschen',
  grant_read_registration_typess: 'Anmeldungen sehen',
  grant_edit_registration_type: 'Anmeldungen bearbeiten',
  grant_create_registration_type: 'Anmeldungen erstellen',
  grant_delete_registration_type: 'Anmeldungen löschen',
  grant_read_staff_registrations: 'Angestellten Anmeldungen sehen',
  grant_edit_staff_registration: 'Angestellten Anmeldungen bearbeiten',
  grant_create_staff_registration: 'Angestellten Anmeldungen erstellen',
  grant_delete_staff_registration: 'Angestellten Anmeldungen löschen',
  grant_read_staff_calendar_birthdays: 'Geburtstagskalender sehen',
  grant_read_staff_calendar_contract_end: 'Befristungskalender sehen',
  grant_edit_family: 'Familien bearbeiten',
  grant_read_families: 'Familien sehen',
  grant_read_vacations: 'Urlaube sehen',
  grant_edit_vacation: 'Urlaube bearbeiten',
  grant_read_renting: 'Vermietung sehen',
  grant_edit_rent: 'Vermietung bearbeiten',
  grant_read_renting_prices: 'Vermietungspreise sehen',
  grant_edit_renting_price: 'Vermietungspreise bearbeiten',
  grant_read_renting_files: 'Vermietungsdateien sehen',
  grant_edit_renting_file: 'Vermietungsdateien bearbeiten',
  grant_delete_renting_price: 'Vermietungspreis löschen',
  grant_edit_driver_task: 'Fahrer-Auftrag bearbeiten',
  grant_read_driver_tasks: 'Fahrer-Auftrag sehen',
  finish: 'Abschließen',
  weight_label: 'Gewicht',
  error_date_to_old: 'Auftrag gesperrt!',
})

export default messages
